import { render, staticRenderFns } from "./StockSourceControls.vue?vue&type=template&id=724f4b00&scoped=true"
import script from "./StockSourceControls.vue?vue&type=script&lang=js"
export * from "./StockSourceControls.vue?vue&type=script&lang=js"
import style0 from "./StockSourceControls.vue?vue&type=style&index=0&id=724f4b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f4b00",
  null
  
)

export default component.exports